import React from "react";
import StatsCardSection from "./StatsCardSection";
import { formatResolutionTime } from "./utils/formatResolutionTime";

const RoleSpecificStats = ({ userInfoData, ticketStats }) => {
  const isManager = userInfoData?.ticket_account_type === "manager";
  const isSupervisor = userInfoData?.ticket_account_type === "supervisor";
  const isAdmin = userInfoData?.ticket_account_type === "admin";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  // Cluster managers use admin stats
  const isAdminLike = isAdmin || isClusterManager;

  const getStatsForRole = () => {
    if (isManager) {
      return {
        totalTickets: ticketStats?.total_tickets || 0,
        ticketsAwaitingAssignment: parseInt(
          ticketStats?.total_opened_tickets || 0
        ),
        ticketsResolved: parseInt(ticketStats?.closed_this_week || 0),
        ticketsReopened: parseInt(ticketStats?.reopened_tickets || 0),
        avgResolutionTime: formatResolutionTime(
          ticketStats?.avg_days,
          ticketStats?.avg_hours,
          ticketStats?.avg_minutes
        ),
      };
    }

    if (isSupervisor) {
      return {
        totalTickets: ticketStats?.total_tickets || 0,
        assignedTickets: ticketStats?.assigned_tickets || 0,
        inProgressTickets: ticketStats?.in_progress_tickets || 0,
        ticketsCompleted: ticketStats?.work_completed_tickets || 0,
        avgResolutionTime: formatResolutionTime(
          ticketStats?.avg_days,
          ticketStats?.avg_hours,
          ticketStats?.avg_minutes
        ),
      };
    }

    if (isAdminLike) {
      return {
        totalTickets: ticketStats?.total_tickets || 0,
        ticketsClosed: ticketStats?.verified_and_closed_tickets || 0,
        closedPercentage: ticketStats?.closed_percentage || "0.00",
        ticketsReopened: ticketStats?.tickets_reopened || 0,
        avgTatHours: ticketStats?.avg_tat_hours || "0.00",
        infraSpend: ticketStats?.infra_spend || "0",
        topSupervisor: ticketStats?.top_supervisor || "N/A",
        slaBreaches: ticketStats?.sla_breaches || 0,
        criticalTickets: ticketStats?.critical_tickets || 0,
        teamUtilization: ticketStats?.team_utilization || "0.00",
      };
    }

    // Default receptionist stats
    return {
      totalTickets: ticketStats?.total_tickets || 0,
      ticketsRaised: ticketStats?.tickets_raised_this_month || 0,
      ticketsClosed: ticketStats?.tickets_closed || 0,
      ticketsReopened: ticketStats?.tickets_reopened || 0,
      avgResolutionTime: formatResolutionTime(
        ticketStats?.avg_days,
        ticketStats?.avg_hours,
        ticketStats?.avg_minutes
      ),
    };
  };

  return (
    <div className="role-specific-stats">
      <StatsCardSection stats={getStatsForRole()} />
    </div>
  );
};

export default RoleSpecificStats;
